import * as NUMBER from 'constant/number'
import React from 'react'
import { Menu } from 'antd'
import { Link, useHistory } from 'react-router-dom'
import _ from 'lodash'
import classnames from 'classnames'
import styles from './index.scss'

const getCollapsed = (site, openSite, openMenu) => (
  <Menu.Item
    icon={
      <img
        className='anticon anticon-home ant-menu-item-icon'
        src={site.icon}
      />
    }
    key={site.uuid}
    onClick={() => {
      openSite(site)()
      openMenu()
    }}
  />
)

const getSubmenu = (category, openCategory) => {
  if (!_.isEmpty(category.sub_categories) && category.show_category) {
    return (
      <Menu.SubMenu
        key={category.uuid}
        title={<span className={styles.subMenuTitle}>
          <Link
            onClick={(e) => e.stopPropagation()}
            to={`/category/${category.uuid}/articles`}
          >{category.name}</Link></span>}
      >
        {category.sub_categories.map((subCategory, i) => (
          subCategory.article > NUMBER.ZERO &&
          <Menu.Item key={subCategory.uuid}>
            <Link to={`/category/${subCategory.uuid}/articles`}>
              {subCategory.name}
            </Link>
          </Menu.Item>

        ))}
      </Menu.SubMenu>)
  } else if (category.show_category) {
    return (
      <Menu.Item
        key={category.uuid}
      >
        <Link
          className={styles.nonSubTitle}
          to={`/category/${category.uuid}/articles`}
        >{category.name}</Link>
      </Menu.Item>)
  }
}

// eslint-disable-next-line max-params
const siteMenus = (possibleSites, site, menuOpen, mobileView, openMenu, setSelectedSites, selectedSite, onSelect) => {
  const history = useHistory()
  const openSite = (site) => (event) => history.push(`/site/${site.uuid}`)
  const openCategory = (category) => (event) => history.push(`/category/${category.uuid}/articles`)
  return possibleSites.map((site, i) => (menuOpen || mobileView ? siteMenuItem(site, openCategory, setSelectedSites, selectedSite, onSelect) : getCollapsed(site, openSite, openMenu)
  ))
}

const siteMenuItem = (site, openCategory, setSelectedSites, selectedSite, onSelect) => {
  if (!_.isEmpty(site.category)) {
    return (<>
      <Menu.SubMenu
        className={classnames(selectedSite === site.uuid && styles.active, styles.subMenu)}
        icon={
          <span>
            <Link
              onClick={(e) => e.stopPropagation()}
              to={`/site/${site.uuid}`}
            > <img
                className='anticon anticon-home ant-menu-item-icon'
                src={site.icon}
              /></Link></span>}
        key={site.uuid}
        title={<span className={styles.subMenuTitle}>
          <Link
            onClick={(e) => {
              e.stopPropagation()
              onSelect({ key: '' })
              setSelectedSites(site.uuid)
            }}
            to={`/site/${site.uuid}`}
          >{site.site_name}</Link></span>}
      >
        {site.category.map((category) => (
          getSubmenu(category, openCategory)
        ))}
      </Menu.SubMenu>
    </>)
  } else {
    return (<>
      <Menu.Item
        className={classnames(selectedSite === site.uuid && styles.active)}
        icon={
          <span className={styles.no_sub_menu}>
            <Link
              onClick={(e) => e.stopPropagation()}
              to={`/site/${site.uuid}`}
            > <img
                className='anticon anticon-home ant-menu-item-icon'
                src={site.icon}
              /></Link></span>}
        key={site.uuid}
      >
        <span>
          <Link
            onClick={(e) => {
              e.stopPropagation()
              onSelect({ key: '' })
              setSelectedSites(site.uuid)
            }}
            to={`/site/${site.uuid}`}
          >{site.site_name}</Link>
        </span>

      </Menu.Item>
    </>
    )
  }
}

export default siteMenus
